import { GALLERY_IMAGES } from "../data/clinic";
import { useLang } from "../i18n/LanguageContext";
import { Reveal, Eyebrow } from "./Reveal";
import BeforeAfter from "./BeforeAfter";

export default function Gallery() {
  const { t } = useLang();
  const g = t.gallery;

  return (
    <section id="gallery" data-testid="gallery-section" className="relative bg-brand-surface py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <Eyebrow>{g.eyebrow}</Eyebrow>
          <h2 className="mt-5 max-w-2xl font-display text-4xl font-normal leading-tight tracking-tight text-brand-ink md:text-5xl">
            {g.heading}
          </h2>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-brand-inksoft">{g.subtitle}</p>
        </Reveal>

        <div className="mt-14 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {GALLERY_IMAGES.map((img, i) => (
            <Reveal key={img.id} delay={i * 0.08}>
              <figure>
                <BeforeAfter
                  before={img.before}
                  after={img.after}
                  beforeLabel={g.before}
                  afterLabel={g.after}
                  alt={g.cases[i]?.title || "Smile transformation"}
                />
                <figcaption className="mt-5">
                  <h3 className="font-display text-xl text-brand-ink">{g.cases[i]?.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-brand-inksoft">{g.cases[i]?.desc}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
